// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cwx7","right":"styles_right__QI5VD"};